import { get, post } from "../../api";
import {
  FAKE_SESSION_LOG_IN,
  FIND_USER_TOKEN_IN_STORAGE,
  GET_USER_DATA_BY_TOKEN,
  LOG_IN_SUCCESS,
  LOG_IN_WITH_PASSWORD,
  LOG_OUT,
  SET_FAKE_SESSION,
  SET_USER_TOKEN,
} from "./authTypes";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { UserToken } from "../../models/UserToken";
import { LoginData } from "../../models/LoginData";
import { FAKE_LOGIN_USE_URL } from "../../api/apiRoutes";

export const logInWithPassword = createAction<LoginData>(LOG_IN_WITH_PASSWORD);
export const login = createAsyncThunk(
  LOG_IN_SUCCESS,
  async (arg: { url: string; data: LoginData }) => await post(arg.url, arg.data)
);
export const findUserTokenInStorage = createAction<void>(FIND_USER_TOKEN_IN_STORAGE);
export const setUserToken = createAction<UserToken>(SET_USER_TOKEN);
export const logOut = createAction<void>(LOG_OUT);
export const getUserDataByToken = createAsyncThunk(GET_USER_DATA_BY_TOKEN, async (url: string) => await get(url));
export const setFakeSession = createAction<UserToken>(SET_FAKE_SESSION);
export const fakeSessionLogIn = createAsyncThunk(FAKE_SESSION_LOG_IN, async () => await post(FAKE_LOGIN_USE_URL));